import * as React from 'react';
import NoAccounts from '@features/workspace/views/banking/components/NoAccounts';
import BankingLayout from '@/components/layout/BankingLayout';

const BankingAccountEmpty: React.FC<any> = () => {
  return (
    <BankingLayout noTabs>
      <NoAccounts />
    </BankingLayout>
  );
};

export default BankingAccountEmpty;
